import React, { FC } from "react";
import {
  makeStyles,
  Box,
  Typography,
  Select,
  MenuItem,
} from "@material-ui/core";
import colors from "../constants/colors";
import { observer } from "mobx-react-lite";

interface IParameterProps {
  parameter: string;
  name: string;
  handleChange: (name: string, value: number) => void;
  value: number;
  options: { value: number; label: string }[];
  disabled?: boolean;
}

export const DropdownParameter: FC<IParameterProps> = observer(
  ({ handleChange, parameter, name, value, options, disabled }) => {
    const classes = styles();

    const onInput = (
      e: React.ChangeEvent<{ name?: string; value: string }>
    ) => {
      e.persist();
      handleChange(e.target.name, Number(e.target.value));
    };

    return (
      <Box className={classes.container}>
        <Typography className={classes.parameterText}>{parameter}</Typography>
        <Box className={classes.control}>
          <Box className={classes.inputContainer}>
            <Select
              disabled={disabled}
              name={name}
              className={classes.select}
              value={value}
              onChange={onInput}
            >
              {options.map(({ label, value: selectorValue }) => (
                <MenuItem key={label} value={selectorValue}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </Box>
        </Box>
      </Box>
    );
  }
);

const styles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
  },
  control: {
    display: "flex",
    alignItems: "center",
  },
  parameterText: {
    textTransform: "uppercase",
    fontWeight: "bold",
    fontSize: 12,
    letterSpacing: 1.5,
    color: colors.dark,
    maxWidth: 100,
  },
  parameter: {
    display: "flex",
  },
  inputContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    margin: "0px 10px",
  },
  select: {
    margin: "0px 20px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "12px",
    },
  },
}));
